class JoinMailingList extends HTMLElement {
  constructor() {
    super();
    
    this.modalBackground = this.getElementsByClassName('bg')[0];
    this.closeButton = this.querySelector('button');
    this.triggerButton = document.getElementById('join-modal-trigger');
    this.docObject = document;
    this.domain = window.location.hostname;
    
    if (this.triggerButton) {
      this.triggerButton.addEventListener('click', (e) => {
        e.preventDefault();
        console.log(e);
        this.openModal();
        this.setCookie('delete');
      });
    }
    
    // console.log(document.cookie.split(';'));
    
    if( this.get_cookie('join') ) {
      // have a cookie
      console.log('have name cookie...');
    }
    if( !this.get_cookie('join') ) {
      // have no cookie
      console.log('have no cookie');
      setTimeout(() => {
        this.openModal();
      }, 5000);
    }

    this.closeButton.addEventListener('click', (e) => {
      // go to the page:
      this.setCookie('new');
      window.location.href = '/pages/join-us';
    })

    this.modalBackground.addEventListener('click', (e) => {
      // console.log(e.target.className);
      // console.log(e.target.classList);
      // console.log(e.target.classList.contains('icon-close'));
      if(e.target.classList.contains('icon-close') || e.target.className === 'bg bg-visible') {
        this.close();
      }
    })

    document.addEventListener(
      'keyup',
      (e) => {
        e.code.toUpperCase() === 'ESCAPE' && this.close();
      }
    );
  }

  connectedCallback() {
  }

  setCookie(action) {
    let expire = false;
    if (action === 'delete') {
      expire = 'Thu, 01 Jan 1970 00:00:00 GMT';
    } else if (action === 'new') {
      // 1000 is one second.
      // 60000 is one minute.
      // 3600000 is one hour.
      // 86400000 is one day.
      const andNow = new Date().getTime();
      expire = new Date(andNow + 86400000).toUTCString();
    }
    if (expire) {
      // console.log(expire);
      this.docObject.cookie = "join=today; expires=" + expire + "; domain=" + this.domain + "; path=/; SameSite=None; Secure";
    }
  }

  get_cookie(name){
    // returns boolean
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
  }


  openModal() {
    this.style.visibility = null;
    this.classList.add('join-modal-visible');
    this.modalBackground.classList.add('bg-visible');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    console.log(event.target);
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  close(focusToggle = true) {
    this.classList.remove('join-modal-visible');
    // this.modalBackground.remove('bg-visible');
    this.modalBackground.classList.remove('bg-visible');
    this.setCookie('new');
  }

}

customElements.define('join-mailing-list', JoinMailingList);
